import React, {
  useContext,
  Fragment,
  useEffect,
  useRef,
  useState
} from "react";
import { useMutation } from "@apollo/react-hooks";
import {
  SortableContainer,
  SortableElement,
  sortableHandle
} from "react-sortable-hoc";
import extrastyles from "styles/extra_modules.module.scss";
import arrayMove from "array-move";
import PageScrollContext from "context/PageScrollContext";
import md5 from "crypto-js/md5";
import {
  Page,
  Range,
  ColorPicker,
  FormGroup,
  Input,
  FormControl,
  Dropdown,
  Switch,
  CustomText,
  Icon,
  Button,
  Alert,
  VideoModal,
  RichEditor,
  ButtonSelect,
  MultiCurrencyModeAlerts,
  Modal
} from "components";
import PreviewContext from "context/PreviewContext";
import ShopContext from "context/ShopContext";
import UserContext from "context/UserContext";
import {
  GOOGLE_FONTS,
  CAMPAIGN_TYPES,
  SHOP_DEFAULT_SETTINGS
} from "lib/globals";
import { SAVE_SHOP_SETTINGS, UPDATE_SHOP_PROP } from "lib/mutations";
import ExtraModules from "screens/campaigns/settings/ExtraModules/index";
import CheckoutButton from "screens/campaigns/settings/ExtraModules/CheckoutButton";
import { Loading, Toast } from "@shopify/app-bridge-react";
import { ShopConstraints } from "Constraints";
import removeTypeName, { removeByType } from "lib/removeTypeName";
import { Run } from "lib/validate";
import { GET_SHOP_SETTINGS } from "Queries";
import { PageHeader } from "components/Page";
import { API, graphqlOperation } from "aws-amplify";
import { APP_DEV } from "aws-exports";
import Axios from "axios";
import { Manager, Reference, Popper } from "react-popper";
import Checkbox from "react-simple-checkbox";
import styles from "styles/cart_screen.module.scss";
import { useTransition } from "react-spring";
import _ from "lodash";
import classNames from "lib/classNames";
import useReactRouter from "use-react-router";
import { SET_ALL } from "reducers/SetItemReducer";
import useRefState from "hooks/useRefState";
import { modules } from "Constraints/CampaignConstraints";

const CodCheckout = (props) => {
  const {
    collapsed,
    setCollapsed,
    setCartIsEmpty,
    setComfirmOrderButtonLoadingEdit,
    editingProductDetails,
    setEditingProductDetails,
    campaign_preview_types
  } = useContext(PreviewContext);
  const stickyAlert = useRef(null);
  const { history, location } = useReactRouter();
  const [scrollTop, setScrollTop, scrollTopRef] = useRefState();
  const [cartActivateLoading, setCartActivateLoading] = useState(false);
  const [videoOne, setVideoOne] = useState(false);
  const [googleFonts, setGoogleFonts] = useState([]);
  const [hideTopBar, setHideTopBar] = useState(false);
  const [showConfirmActivate, setShowConfirmActivate] = useState(false);
  const [campaign_preview_visible, setCampaign_preview_visible] =
    useState(false);
  const campaign_preview_content_ref = useRef(null);
  const shopContext = useContext(ShopContext);
  const user = useContext(UserContext);
  const [editModalVisibility, setEditModalVisibility] = useState(false);
  const [addModalVisibility, setAddModalVisibility] = useState(false);

  const [selectedModule, setSelectedModule] = useState(null);
  const {
    state,
    discard,
    validationErrors,
    setValidationErrors,
    dispatch,
    setItem
  } = shopContext;

  const {
    settings: {
      cod_settings: { form, checkout_mode }
    }
  } = state;
  // const filterSettings = (settings) =>
  // 	_.merge(
  // 		{},
  // 		SHOP_DEFAULT_SETTINGS(),
  // 		removeByType(
  // 			removeTypeName(
  // 				Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
  // 			),
  // 			(v) => v !== '' && v !== null
  // 		)
  // 	);

  const filterSettings = (settings) => {
    return removeByType(
      removeTypeName(
        Object.fromEntries(
          Object.entries(settings).filter(
            ([key]) => !["settingsSaved"].includes(key)
          )
        )
      ),
      (v) => v !== "" && v !== null
    );
    // _.mergeWith(
    // 	SHOP_DEFAULT_SETTINGS(),
    // 	removeByType(
    // 		removeTypeName(
    // 			Object.fromEntries(Object.entries(settings).filter(([key]) => !['settingsSaved'].includes(key)))
    // 		),
    // 		(v) => v !== '' && v !== null
    // 	),
    // 	(objValue, srcValue) => srcValue && _.isArray(srcValue) ? srcValue : undefined
    // );
  };

  let [saveShopSettings, { data, error, loading }] = useMutation(
    SAVE_SHOP_SETTINGS,
    {
      refetchQueries: [
        {
          query: GET_SHOP_SETTINGS,
          variables: {
            userId: user.attributes.website
          }
        }
      ]
    }
  );
  const transitions = useTransition(
    !_.isEqual(state.original_settings, state.settings) && !hideTopBar,
    null,
    {
      from: { position: "absolute", opacity: 0 },
      enter: { opacity: 1 },
      leave: { opacity: 0 },
      config: {
        duration: 300
      }
    }
  );
  const validate = (state, specific = []) =>
    Run(state, specific, {
      errors: validationErrors,
      setErrors: setValidationErrors,
      constraints: ShopConstraints
    });
  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newOrder = arrayMove(form, oldIndex, newIndex);
    setItem("settings.cod_settings.form", newOrder);
    // console.log(newOrder)
    // modules = newOrder
    // this.props.edit('modules', 'order', newOrder);
    // setModules(newOrder);
  };

  const deleteModule = (index) => {
    const newOrder = form.slice();
    newOrder.splice(index, 1);
    setItem("settings.cod_settings.form", newOrder);
  };
  const editModule = (index, module) => {
    const newForm = form.slice();
    newForm[index] = module;
    setItem("settings.cod_settings.form", newForm);
  };
  const addModule = (module) => {
    const newForm = form.slice();
    newForm.push(module);
    setItem("settings.cod_settings.form", newForm);
  };

  const save = (assign = {}, checkRTL = true) => {
    // console.log("state.settings")
    // console.log(state.settings)
    // return
    if (validate(state)) return;
    if (
      checkRTL &&
      Object.keys(state.original_settings || {}).length &&
      state.settings.rtl !== state.original_settings.rtl
    ) {
      console.log(
        "updating theme",
        state.settings.rtl,
        state.original_settings.rtl,
        state.settings.active
      );
      // return activateCart(state.settings.active, true, state.settings.rtl);
    }

    saveShopSettings({
      variables: {
        id: user.attributes.website,
        input: filterSettings(Object.assign(state.settings, assign))
      }
    });
  };

  const activateCart = async (active, confirmed = false, rtl = null) => {
    if (
      active &&
      !confirmed &&
      !state.settingsSaved &&
      _.isEqual(SHOP_DEFAULT_SETTINGS, state.settings)
    ) {
      return setShowConfirmActivate(true);
    }
    // setCartActivateLoading(true);
    // const { success } = await API.post("API_GATEWAY_NEW", "/cart/activate", {
    //   body: { active, rtl: rtl === null ? state.settings.rtl : rtl }
    // });
    // setCartActivateLoading(false);
    return save({ active }, false);
  };

  const handleOutSideClick = (event) => {
    if (!campaign_preview_content_ref.current) return;
    else if (campaign_preview_content_ref.current.contains(event.target))
      return;
    setCampaign_preview_visible(false);
  };

  useEffect(() => {
    if (campaign_preview_visible)
      document.addEventListener("mousedown", handleOutSideClick, false);
    else document.removeEventListener("mousedown", handleOutSideClick, false);
    return () => {
      document.removeEventListener("mousedown", handleOutSideClick, false);
    };
  }, [campaign_preview_visible]);

  useEffect(() => {
    // if (typeof state.settings.multiCurrencyMode !== 'boolean') {
    // 	setItem('settings.multiCurrencyMode', false);
    // }
    async function getGoogleFonts () {
      const { data } = await Axios.get(
        `https://www.googleapis.com/webfonts/v1/webfonts?sort=popularity&key=AIzaSyCYLq50twmAe1_7jITZuehrERZWOjNqBCY`
      );
      setGoogleFonts(
        data.items.map(({ family, variants }) => ({
          label: family,
          value: `${family}:${variants.join()}`
        }))
      );
    }
    getGoogleFonts();
  }, []);

  useEffect(() => {
    setHideTopBar(!!data);
    if (APP_DEV) setTimeout(() => setHideTopBar(false), 1500);
  }, [data]);
  return (
    <Page
      background="none"
      getScrollTop={({ scrollTop }) => {
        setScrollTop(scrollTop);
      }}
      padding={0}
      header={{
        title: "Cash on Delivery Checkout - Customization and Settings",
        actions: [
          {
            text: "Back to settings",
            type: "secondary",
            loading: false,
            onClick: () => history.push("/settings" + location.search)
          }
        ]
      }}
      TopContent={{
        transitions,
        render: () => (
          <Alert
            type="save_settings"
            title="unsaved changes"
            borderPosition="none"
            paddingX="px-6"
            actions={[
              {
                text: "Discard",
                type: "secondary",
                loading: false,
                onClick: () => discard()
              },
              {
                text: "Save",
                type: "primary",
                loading: loading || cartActivateLoading,
                onClick: () => save()
              }
            ]}
          />
        )
      }}
    >
      <Fragment>
        {data && (
          <Toast
            content="Cart settings has been saved"
            duration={3000}
            onDismiss={() => {
              setHideTopBar(false);
            }}
          />
        )}
        {(loading || cartActivateLoading) && <Loading />}
        <FormGroup
          label="Create Cash on Delivery Form"
          info={`Add the feilds you want your order form to have. You can add, edit , drag'n'drop and remove fields.`}
        >
          <ModulesList
            useDragHandle
            {...{
              form,
              onSortEnd,
              deleteModule,
              setSelectedModule,
              setEditModalVisibility
            }}
          />
          <FormControl>
            <div>
              <Button
                text="+ Add New Field"
                type={
                  validationErrors["target.selected"] &&
                    !!validationErrors["target.selected"][0]
                    ? "danger"
                    : "primary"
                }
                onClick={() => {
                  setAddModalVisibility(true);
                }}
                style={{ width: "100%" }}
              />
            </div>
          </FormControl>
        </FormGroup>
        {/* <FormGroup label="Customize checkout button" info="Keep these settings simple and to the point">
					<FormControl
						label="display cart on RTL"
						withSwitch={[shopContext, 'settings.rtl']}
						info="Enable this if your store language uses right to left scripts."
					/>
				</FormGroup> */}
        <FormGroup
          label="Customize checkout button"
          info="Keep these settings simple and to the point"
        >
          <CustomText
            context={shopContext}
            placeholder="Confirm Order"
            hasColor={true}
            label="Confirm order text"
            path="settings.cod_settings.confirm_button"
          />

          <FormControl label="checkout button colors">
            <ColorPicker
              text="background"
              BindToContext={[
                shopContext,
                "settings.cod_settings.confirm_button.background"
              ]}
            />
            {/* <ColorPicker
              text="hover background"
              BindToContext={[
                shopContext,
                "settings.cod_settings.confirm_button.hoverBackground"
              ]}
            /> */}
          </FormControl>
          <CustomText
            context={shopContext}
            placeholder="processing"
            hasColor={true}
            hasNumber={false}
            onFocus={() => setComfirmOrderButtonLoadingEdit(true)}
            onBlur={() => setComfirmOrderButtonLoadingEdit(false)}
            label="checkout button loading text"
            path="settings.cod_settings.loading_button"
          />
        </FormGroup>
        <FormGroup>
          <FormControl
            label="Error message"
            error={validationErrors["settings.cod_settings.error_message"]}
          >
            <Input
              type="text"
              BindToContext={[
                shopContext,
                "settings.cod_settings.error_message"
              ]}
              hasError={
                !!validationErrors["settings.cod_settings.error_message"]
              }
            />
          </FormControl>
        </FormGroup>

        <EditModal
          {...{
            editModalVisibility,
            setEditModalVisibility,
            selectedModule,
            editModule
          }}
        />
        {addModalVisibility && (
          <AddModal
            {...{
              addModalVisibility,
              setAddModalVisibility,
              addModule
            }}
          />
        )}
      </Fragment>
    </Page>
  );
};

const ModulesList = SortableContainer(
  ({ form, deleteModule, setSelectedModule, setEditModalVisibility }) => {
    return (
      <FormControl isSingleCol={true}>
        <div>
          {!!form &&
            form.map((module, index) => {
              return (
                <Module
                  {...{
                    setEditModalVisibility,
                    module,
                    setSelectedModule,
                    deleteModule,
                    index
                  }}
                  itemIndex={index}
                  key={index}
                />
              );
            })}
        </div>
      </FormControl>
    );
  }
);

const Module = SortableElement(
  ({
    module,
    deleteModule,
    itemIndex,
    setSelectedModule,
    setEditModalVisibility
  }) => {
    const { label, isRequired, type } = module;
    return (
      <div className={extrastyles.module} data-active={true}>
        <div
          className={extrastyles.header}
          data-has-children={false}
          data-one-row={true}
        >
          <div className={extrastyles.header_wrapper}>
            <b className={extrastyles.name}>{`${label} ${isRequired ? "*" : ""
              }`}</b>
          </div>
          <div className={classNames("flex ")}>
            <Button
              className={classNames("mx-2 ")}
              icon="edit"
              type="circle-warning"
              onClick={() => {
                setSelectedModule([itemIndex, module]);
                setEditModalVisibility(true);
              }}
            />
            {type !== "name" && (
              <Button
                className={classNames("mx-2 ")}
                icon="trash"
                type="circle-danger"
                onClick={() => deleteModule(itemIndex)}
              />
            )}
          </div>
        </div>
        <Grip active={true} />
      </div>
    );
  }
);

const Grip = sortableHandle(({ active }) => {
  return (
    <div className={extrastyles.grip} data-active={active}>
      <Icon icon="angle-up" />
      <Icon icon="angle-down" />
    </div>
  );
});

const EditModal = ({
  editModalVisibility,
  setEditModalVisibility,
  selectedModule,
  editModule
}) => {
  const [module, setModule] = useState(null);
  useEffect(() => {
    if (selectedModule) {
      setModule({ ...selectedModule[1] });
    }
  }, [selectedModule]);

  const handleChange = (value, attribute) => {
    setModule({
      ...module,
      [attribute]: value
    });
  };

  const save = () => {
    editModule(selectedModule[0], module);
    setEditModalVisibility(false);
    // setSelectedModule(null)
  };

  return (
    <Modal
      visible={editModalVisibility && module}
      title="Edit"
      onClose={() => setEditModalVisibility(false)}
    >
      {(close, setTitle) =>
        module ? (
          <div className={classNames("px-2 h-full flex flex-col")}>
            <div className={classNames("h-full ")}>
              <FormControl label="Title">
                <Input
                  value={module.label}
                  onChange={(v) => handleChange(v, "label")}
                />
              </FormControl>
              <FormControl label="Placeholder">
                <Input
                  value={module.placeholder}
                  onChange={(v) => handleChange(v, "placeholder")}
                />
              </FormControl>
              <FormControl label="Required">
                <Switch
                  value={module.isRequired}
                  onChange={(v) => handleChange(v, "isRequired")}
                />
              </FormControl>
            </div>

            <div className={classNames("flex justify-end ")}>
              <Button text="Save" onClick={save} />
            </div>
          </div>
        ) : (
          <div></div>
        )
      }
    </Modal>
  );
};

const AddModal = ({ addModalVisibility, setAddModalVisibility, addModule }) => {
  const [label, setLabel] = useState("Titre");
  const [isRequired, setIsRequired] = useState(false);
  const [type, setType] = useState("string");
  const [options, setOptions] = useState([]);
  const [placeholder, setPlaceholder] = useState("");

  const save = () => {
    addModule({
      label,
      isRequired,
      type,
      options,
      placeholder
    });
    setAddModalVisibility(false);
  };

  const showOptions = ["dropdown", "checkbox", "radio"];

  return (
    <Modal
      visible={addModalVisibility}
      title="Add Field"
      onClose={() => setAddModalVisibility(false)}
    >
      {(close, setTitle) => (
        <div className={classNames("px-2 ")}>
          <FormControl label="Field type">
            <Dropdown
              options={[
                { value: "name", label: "Full name" },
                { value: "email", label: "Email" },
                { value: "string", label: "Text" },
                { value: "textarea", label: "Text area" },
                { value: "dropdown", label: "Dropdown list" }
                // { value: 'checkbox', 	label: 'Checkbox' },
                // { value: 'radio', 		label: 'Radio' },
              ]}
              onChange={(value) => setType(value)}
              value={type}
            />
          </FormControl>
          <FormControl label="Title">
            <Input value={label || ""} onChange={setLabel} />
          </FormControl>
          {showOptions.indexOf(type) === -1 && (
            <FormControl label="Placeholder">
              <Input value={placeholder || ""} onChange={setPlaceholder} />
            </FormControl>
          )}
          {showOptions.indexOf(type) !== -1 && (
            <FormControl label="Options">
              <Dropdown
                isCreatable={true}
                isMulti={true}
                onChange={setOptions}
                value={options || []}
              />
            </FormControl>
          )}

          <FormControl label="Required">
            <Switch value={isRequired} onChange={setIsRequired} />
          </FormControl>
          <div className={classNames("flex justify-end py-2")}>
            <Button text="Save" onClick={save} />
          </div>
        </div>
      )}
    </Modal>
  );
};

export default CodCheckout;
